import update from 'immutability-helper';

export default function setMapData(state, action) {
  // console.log('SET_MAP_DATA', action.data.features)

  return update(state, {
    mapData: {
      $set: action.data.features,
    },
    gettingMap: {
      $set: false,
    },
  });
}
